/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon16Regular = forwardRef('GovKoFssIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.95.65a.65.65 0 0 0-1.3 0v.71a6.65 6.65 0 0 0 0 13.28v.71a.65.65 0 1 0 1.3 0v-.767a6.652 6.652 0 0 0 0-13.166V.65Zm-1.3 2.011a5.35 5.35 0 0 0 0 10.678v-1.066a4.288 4.288 0 0 1 0-8.546V2.66Zm0 2.07a3.288 3.288 0 0 0 0 6.538v-.9a2.394 2.394 0 0 1 0-4.737V4.73Zm0 1.92a1.394 1.394 0 0 0 0 2.698V6.651Zm1.3 6.615V2.734a5.352 5.352 0 0 1 0 10.532Z" })));
});
